import { handleMessageChange } from "./handleMessageChange";

export function handleUpdateCardButton(
  selectedNode,
  cardIndex,
  componentIndex,
  newData,
  nodes,
  setNodes,
  setCards,
  buttonIndex 
) {
  let updatedCards = selectedNode.data.cards;
  const updatedCard = { ...updatedCards[cardIndex] };
  const updatedComponents = [...updatedCard.components];
  let updatedComponent = updatedComponents[componentIndex];

  // Si on souhaite mettre à jour un bouton spécifique dans un composant BUTTONS
  if (
    buttonIndex !== undefined &&
    updatedComponent.type === "BUTTONS" &&
    Array.isArray(updatedComponent.buttons)
  ) {
    const updatedButtons = updatedComponent.buttons.map((button, idx) => {
      if (idx === buttonIndex) {
        // Met à jour le bouton en fusionnant ses propriétés existantes avec newData
        return { ...button, ...newData };
      }
      return button;
    });
    updatedComponent = { ...updatedComponent, buttons: updatedButtons };
  } else {
    // Sinon, on met à jour directement le composant
    updatedComponent = { ...updatedComponent, ...newData };
  }

  updatedComponents[componentIndex] = updatedComponent;
  updatedCard.components = updatedComponents;
  updatedCards[cardIndex] = updatedCard;

  handleMessageChange("cards", updatedCards, nodes, setNodes);
  setCards(updatedCards);
}
